// @ts-nocheck

import { BasketStatuses } from '../../../types/basket';

/**
 * Return the nextState corresponding to the BASKET_SET_STATUS_ERROR action
 *
 * @static
 * @param  {Object} state  The actual state
 * @param  {Object} action The action to reduce
 * @return {Object}        Return the new state.
 */
const basketSetStatusError = (state, action) => {
  const { status, error } = state;
  const { error: nextError } = action.payload;
  if (status !== BasketStatuses.ERROR || error !== nextError) {
    return {
      ...state,
      status: BasketStatuses.ERROR,
      error: nextError,
      betslipId: undefined,
      additionalMessage: undefined,
    };
  }
  return state;
};

export default basketSetStatusError;
